var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTurnLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.327 20.818h8.214a2.063 2.063 0 0 0 2.053-2.073v-8.29c0-1.145-.919-2.073-2.053-2.073H5.327a2.063 2.063 0 0 0-2.054 2.073v8.29c0 1.145.92 2.073 2.054 2.073Z",
  stroke: "#fff",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 3.667h6.667C18.507 3.667 20 4.5 20 7v5M10 3.667 12.5 2M10 3.667l2.5 1.666",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgTurnLeft;